import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import * as actions from './action'
import getters from './getters'
import { device } from '../utils/storage'

Vue.use(Vuex)

const state = {
  global: {
    isPc: device,
    language: 1,
    menuSelected: 'activity',
    showAgreement: false,
    agreement:'',
    currentActivityEnd: 0,
  },
  rule:{
   content:'',
   show:false
  },
  tempName:'',
  preCid:'',
  agreement:'',
  bread: ['内购', '全部产品'],
  campaign: {},
  campaignList: [],
  categories: [],
  goods: [],
  searchKey: '',
  currentPage: 1,
  filter: {

  },
  cartList: {
    cartNum: 0,
  },
  user: {}
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
})



// WEBPACK FOOTER //
// ./src/store/state.js